<template>
  <div v-a11y-tab>
    <a-select
      show-search
      :placeholder="$t('year')"
      option-filter-prop="children"
      :filter-option="filterOption"
      :value="value"
      @change="handleChange"
      class="year-picker"
    >
      <a-select-option v-for="year in years" :key="year" :value="year">{{ year }}</a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
  },
  computed: {
    years() {
      const currYear = new Date().getFullYear();
      const startYear = currYear - 100;

      const years = [];

      for (let i = currYear; i >= startYear; i -= 1) {
        years.push(i);
      }

      return years;
    },
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.indexOf(input) >= 0;
    },
    handleChange(year) {
      this.$emit('input', year);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

.year-picker {
  width: 100px;
}

@media (max-width: $page-mobile-large-breakpoint) {
  .year-picker {
    width: 75px;
  }
}
</style>
